import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const LegalEntityPartner = () => {
  return (
    <Flow>
      <Flow.Progress label='Cadastro do sócio' />

      <Flow.StepList>
        <Step name='social-contract-partner' />
        <Step name='face-detection' />
        <Step name='document-partner' />

        <Step name='phone-partner' />
        <Step name='address' />
        <Step name='occupation-partner' />
        <Step name='income-partner' />
        <Step name='legal-entity-income' />
        <Step name='pep-partner' />
        <Step name='bank-account' />
        <Step name='terms' />
      </Flow.StepList>
    </Flow>
  );
};
